export const indexCopy = {
  index_headline: "TypeScript es <bold>JavaScript Escalable.</bold>",
  index_byline: "TypeScript extiende JavaScript al añadir tipos al lenguaje.",
  index_summary:
    "TypeScript agiliza la experiencia de desarrollo al capturar errores y proveer soluciones incluso antes de ejecutar tu código.",
  index_locations:
    "Cualquier navegador, cualquier sistema operativo, en donde JavaScript se ejecuta. Completamente Código Abierto.",

  index_what_is: "¿Qué es TypeScript?",

  index_what_is_js: "JavaScript y mucho más!",
  index_what_is_js_copy: `
  <p>TypeScript es un lenguaje de programación libre y de código abierto construido sobre JavaScript, una de las herramientas más utilizadas a nivel mundial, que esencialmente añade tipos estáticos.</p>
  
  <p>Los tipos proveen una manera de describir la forma de un objeto, suministrando mejor documentación y permitiendo a TypeScript validar que el código funciona correctamente.</p>
  
  <p>Denotar tipos es opcional en TypeScript, porque la inferencia de tipos le permite obtener mucha más potencia sin escribir código adicional.</p>`,

  index_trust: "Resultados Confiables",
  index_trust_copy_a: `Todo código en JavaScript tambien es válido en TypeScript. Puedes tener validación de errores de tipo, pero eso no te detendrá de ejecutar el JavaScript resultante. Si bien puedes optar por un comportamiento más estricto, eso significa que aún tienes el control.`,
  index_trust_copy_b: `TypeScript code is transformed into JavaScript code via the TypeScript compiler or <babel>Babel</babel>. This JavaScript is clean, simple code which runs anywhere JavaScript runs: In a browser, on Node.JS or in your apps.`,
  index_standards: "Evolucionando Con Estandares.",
  index_standards_copy: `
    <p>El equipo detrás de TypeScript contribuye al comité TC39 que ayuda a guiar la evolución del lenguaje JavaScript.</p>
  
    <p>Cuando nuevas caracteristicas han alcanzado la etapa 3, es cuando se encuentran listas para ser incluidas en TypeScript.</p>
    
    <p>Por ejemplo el equipo de TypeScript logró propuestas como encadenamiento opcional, operador de fusión nulo, expresiones de excepciones e índices de coincidencia RegExp.</p>`,

  index_gradual: "Adopción Gradual",
  index_gradual_copy: `
  <p>La adopción de TypeScript no es una decisión binaria, puede comenzar anotando JavaScript existente con JSDoc, luego cambiar algunos archivos para que TypeScript los verifique y, con el tiempo, preparar su código para convertirlo por completo.</p>
  
  <p>La inferencia de tipos de TypeScript significa que no tiene que anotar su código hasta que desee más seguridad.</p>`,

  index_dts: "Tipado en todas partes",
  index_dts_copy: `
  <p>El código JavaScript en gran parte del mundo no tiene tipado y la inferencia solo puede llegar hasta donde puede. Para afrontar esto, el equipo de TypeScript ayuda a mantener <dt>Definitely Typed</dt> - un proyecto comunitario para proporcionar tipos y documentación en línea a JavaScript existente.</p>
  
  <p>Este proyecto permite a la comunidad mantener definiciones de tipo para bibliotecas JavaScript sin ejercer presión adicional sobre sus mantenedores.</p>`,

  index_tools: "Herramientas consistentemente buenas",
  index_tools_copy: `
    <p>Al manejar gran parte de la integración del editor dentro de TypeScript, puede obtener una experiencia consistente trabajando en muchos editores.</p>
  
    <p>Esto le permite saltar fácilmente entre editores como <vs>Visual Studio</vs>, <vsc>Visual Studio Code</vsc>, <nova>Nova</nova>, <atom>Atom</atom>, <subl>Sublime Text</subl>, <emacs>Emacs</emacs>, <vim>Vim</vim>, <webs>WebStorm</webs> y <eclipse>Eclipse</eclipse>.</p>
  
    <p>La integración del editor de TypeScript admite JavaScript, por lo que es muy probable que ya esté usando TypeScript bajo cuerdas.</p>
    `,

  index_started_title: "Empezar",
  index_started_handbook: "Manual",
  index_started_handbook_blurb: "Aprende el lenguaje",
  index_started_guides: "Referencias",
  index_started_guides_blurb: "Reseñas de alto nivel",
  index_started_ref: "Referencia",
  index_started_ref_blurb: "Entendiendo la herramienta",
  index_started_community: "Comunidad",
  index_started_community_blurb: "Mantente al día",
  index_install: "Instalar TypeScript",
  index_install_ref: `
    <p>Puedes instalar TypeScript a tráves de npm<pre>npm install -g typescript</pre>
    <p>Y luego ejecutar el compilador con el comando <code>tsc</code><pre>npm install -g typescript</pre>
    `,
  index_releases: "Publicaciones trimestrales",
  index_releases_pt1: "Nuestro siguiente lanzamiento es ",
  index_releases_pt2: ", el cual está planificado para ",
  index_releases_released: "Lanzado",
  index_releases_beta: "Beta",
  index_releases_rc: "RC",

  index_migration_title: "Historias de migraciones",
  index_migration_oss: "Código abierto con TypeScript",
  index_videos_title: "Observa a TypeScript en acción",
}
